import { useEffect } from 'react';
import { Alert, ButtonIcon } from '@backstage/ui';
import { RiCloseLine } from '@remixicon/react';

export type AccessToastState = {
  message: string;
  severity: 'success' | 'error';
};

type AccessToastProps = {
  toast: AccessToastState;
  onClose: () => void;
};

export const AccessToast = ({ toast, onClose }: AccessToastProps) => {
  useEffect(() => {
    if (!toast.message) {
      return undefined;
    }

    const timeout = window.setTimeout(onClose, 3000);
    return () => window.clearTimeout(timeout);
  }, [onClose, toast.message]);

  if (!toast.message) {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: 100,
        left: 0,
        right: 0,
        display: 'flex',
        justifyContent: 'center',
        zIndex: 1700,
      }}
    >
      <Alert
        status={toast.severity === 'error' ? 'danger' : 'success'}
        icon
        title={toast.message}
        customActions={
          <ButtonIcon
            aria-label="Close notification"
            icon={<RiCloseLine />}
            onPress={onClose}
            size="small"
            variant="tertiary"
          />
        }
      />
    </div>
  );
};
